import { SB } from '@play-co/replicant';

/**
 * @deprecated A/B 0474 resolved to control. Kept for existing user state and
 * queued scheduled action compatibility.
 */
export const crateWaitingSchema = {
  crateWaiting: SB.object({
    /** creativeAssetIDs already sent in the current rotation cycle */
    sentCreatives: SB.array(SB.string()).default([]),
    /** Last creative sent — avoids a back-to-back repeat across a cycle boundary. */
    lastSentId: SB.string().optional(),
    /** Fixed-schedule crate-waiting chain kicked off once */
    scheduleStarted: SB.boolean().default(false),
    /** Set true on a genuine crate-open — the crate-skipper gate (see isCrateSkipper). */
    openCrate: SB.boolean().default(false),
  }).optional(),
};
